import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ProjektRettighed, PublicProjektSag } from 'src/app/api/models';
import { InitiativPligtHelper } from 'src/app/core/helpers/initiativ-pligt-helper';

@Component({
  selector: 'bom-sag-initiativpligt',
  templateUrl: './sag-initiativpligt.component.html',
  styleUrls: ['./sag-initiativpligt.component.scss'],
})
export class SagInitiativpligtComponent implements OnInit, OnChanges {
  @Input()
  sag: PublicProjektSag;

  @Input()
  projektRettighed: ProjektRettighed;

  initiativpligt: string;

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.sag) {
      this.initiativpligt = InitiativPligtHelper.GetInitiativPligtText(
        this.sag,
        this.projektRettighed
      );
    }
  }
}
